import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PlanUpgrade from "../PlanUpgrade";

const QuickReviewUpgrade = props => (
  <div className="context-quickreview animated fadeinright">
    <div className="metalens-head">
      <span className="metalens-head-title">Metalens</span>

      <span className="metalens-head-info-circle">
        <FontAwesomeIcon icon={["far", "info-circle"]} className="" />
      </span>
    </div>
    <div className="metalesnse-upgrade-container">
      <img
        src="https://d34fwl795uvawg.cloudfront.net/images/upgrade-popup/metalens.png"
        className="metalens-upload-image"
        alt="attachment"
      />
      <div className="attachment-upgrade-txt">
        {props.isSharedDocument
          ? "To enable metalens, contact the document sender. Metalens uses machine learning to identify and highlight important data in the document such as names, amount and dates for easy comprehension and navigation of documents."
          : "To add metalens, upgrade to premimum plan"}
      </div>
      <PlanUpgrade type="metalense" isSharedDocument={props.isSharedDocument} />
    </div>
  </div>
);

export default QuickReviewUpgrade;
